import { orientationAccessorConfig } from 'projectSections/designPanels/PanelModuleGrid/accessors/orientation'
import { StudioSystemType } from 'types/global'
import { MountingCalcResult } from '../../types'
import { setPanelSpacing } from '../../utils'
import { MIN_GROUND_CLEARANCE_MM, SolarPortConfig, SolarPortRelativeTilt } from './SolarPortTypes'

export function solarPortOnApply(system: StudioSystemType): void {
  system.moduleGrids().forEach((moduleGrid) => {
    orientationAccessorConfig.set({ moduleGrid, value: 'portrait' })
  })
}

export function solarPortAfterCalculate(system: StudioSystemType, mountingResults: MountingCalcResult[]): void {
  mountingResults.forEach((result) => setPanelSpacing(system, result))
}

export function solarPortOnSync(system: StudioSystemType): void {
  const spData = system.integration_json?.solarPortGroundMount
  const groundSlope = Number(spData?.groundSlope ?? 0)
  const relativeTilt = Number(spData?.relativeTilt ?? 30)
  const desiredSlope = groundSlope + relativeTilt
  system.moduleGrids().forEach((moduleGrid) => {
    const currentSlope = moduleGrid.getSlope()
    // 0.001 is the tolerance for floating-point precision issue
    if (Math.abs(currentSlope - desiredSlope) > 0.001) {
      const grid = moduleGrid as any
      grid.setSlope(desiredSlope)
      window.SceneHelper.snapModuleGridToGroundLevel(moduleGrid)
    }

    const currentPanelTiltOverride = (moduleGrid as any).panelTiltOverride
    if (currentPanelTiltOverride !== null) {
      ;(moduleGrid as any).panelTiltOverride = null
    }

    // Use Standard/Flush mount for SolarPort 2 in Portrait to keep panels contiguous.
    const currentPanelConfig = moduleGrid.getPanelConfiguration()
    if (currentPanelConfig !== 'STANDARD') {
      window.editor.execute(new window.SetPanelConfigurationCommand(moduleGrid, 'panelConfiguration', 'STANDARD'))
    }
  })

  const portraitConfig = (spData?.portraitConfig as SolarPortConfig) ?? '1inP'
  const clearanceKey = `${portraitConfig}_${relativeTilt}`
  const lastClearanceKey = spData?._lastAppliedClearanceConfig as string | undefined
  if (clearanceKey !== lastClearanceKey) {
    const minClearanceMm = MIN_GROUND_CLEARANCE_MM[portraitConfig]?.[relativeTilt as SolarPortRelativeTilt]
    if (minClearanceMm) {
      const minClearanceMeters = minClearanceMm / 1000
      system.moduleGrids().forEach((moduleGrid) => {
        window.editor.execute(
          new window.SetPanelConfigurationCommand(moduleGrid, 'groundClearance', minClearanceMeters)
        )
      })
    }
    if (system.integration_json?.solarPortGroundMount) {
      system.integration_json.solarPortGroundMount._lastAppliedClearanceConfig = clearanceKey
    }
  }
}
